"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _BackgroundColorContext = _interopRequireDefault(require("../BackgroundColorContext"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcProgressBar = function DxcProgressBar(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$helperText = _ref.helperText,
      helperText = _ref$helperText === void 0 ? "" : _ref$helperText,
      _ref$overlay = _ref.overlay,
      overlay = _ref$overlay === void 0 ? false : _ref$overlay,
      value = _ref.value,
      _ref$showValue = _ref.showValue,
      showValue = _ref$showValue === void 0 ? false : _ref$showValue,
      margin = _ref.margin;
  var colorsTheme = (0, _useTheme["default"])();
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      valueProgressBar = _useState2[0],
      setValueProgressBar = _useState2[1];

  (0, _react.useEffect)(function () {
    setValueProgressBar(value === null || value === undefined || value < 0 ? 0 : value >= 0 && value <= 100 ? value : 100);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.progressBar
  }, /*#__PURE__*/_react["default"].createElement(BackgroundProgressBar, {
    overlay: overlay
  }, /*#__PURE__*/_react["default"].createElement(ProgressBarContainer, {
    overlay: overlay,
    margin: margin
  }, /*#__PURE__*/_react["default"].createElement(InfoProgressBar, null, /*#__PURE__*/_react["default"].createElement(ProgressBarLabel, {
    overlay: overlay,
    backgroundType: backgroundType,
    "aria-label": label || undefined
  }, label), /*#__PURE__*/_react["default"].createElement(ProgressBarProgress, {
    overlay: overlay,
    showValue: showValue,
    backgroundType: backgroundType,
    value: valueProgressBar
  }, valueProgressBar, " %")), /*#__PURE__*/_react["default"].createElement(LinearProgress, {
    role: "progressbar",
    helperText: helperText,
    "aria-valuenow": showValue ? valueProgressBar : undefined
  }, /*#__PURE__*/_react["default"].createElement(LinearProgressBar, {
    backgroundType: backgroundType,
    variant: value === null || value === undefined ? "indeterminate" : "determinate",
    container: "first",
    value: valueProgressBar
  })), helperText && /*#__PURE__*/_react["default"].createElement(HelperText, {
    overlay: overlay,
    backgroundType: backgroundType
  }, helperText))));
};

var BackgroundProgressBar = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  min-width: 100px;\n  width: 100%;\n"])), function (_ref2) {
  var overlay = _ref2.overlay,
      theme = _ref2.theme;
  return overlay ? "background-color: ".concat(theme.overlayColor, ";\n      opacity: 0.8;\n      width: 100%;\n      justify-content: center;\n      height: 100vh;\n      align-items: center;\n      max-width: 100%;\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      z-index: 1300;") : "background-color: \"transparent\";";
});

var ProgressBarContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  z-index: ", ";\n  width: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return props.overlay === true && "100" || "0";
}, function (props) {
  return props.overlay === true ? "80%" : "100%";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var InfoProgressBar = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  width: 685px;\n  flex-wrap: wrap;\n  width: 100%;\n  margin-bottom: 8px;\n  align-items: baseline;\n  justify-content: space-between;\n"])));

var ProgressBarLabel = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])), function (props) {
  return props.theme.labelFontFamily;
}, function (props) {
  return props.theme.labelFontStyle;
}, function (props) {
  return props.theme.labelFontSize;
}, function (props) {
  return props.theme.labelFontWeight;
}, function (props) {
  return props.theme.labelFontTextTransform;
}, function (props) {
  return props.backgroundType === "dark" ? props.theme.labelFontColorOnDark : props.overlay === true ? "#FFFFFF" : props.theme.labelFontColor;
});

var ProgressBarProgress = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  color: ", ";\n  display: ", ";\n  flex-shrink: 0;\n"])), function (props) {
  return props.theme.valueFontFamily;
}, function (props) {
  return props.theme.valueFontStyle;
}, function (props) {
  return props.theme.valueFontSize;
}, function (props) {
  return props.theme.valueFontWeight;
}, function (props) {
  return props.theme.valueFontTextTransform;
}, function (props) {
  return props.backgroundType === "dark" ? props.theme.valueFontColorOnDark : props.overlay === true ? "#FFFFFF" : props.theme.valueFontColor;
}, function (props) {
  return props.value !== undefined && props.value !== null && props.showValue === true && "block" || "none";
});

var HelperText = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: 1.5em;\n"])), function (props) {
  return props.backgroundType === "dark" ? props.theme.helperTextFontColorOnDark : props.overlay === true ? "#FFFFFF" : props.theme.helperTextFontColor;
}, function (props) {
  return props.theme.helperTextFontFamily;
}, function (props) {
  return props.theme.helperTextFontSize;
}, function (props) {
  return props.theme.helperTextFontStyle;
}, function (props) {
  return props.theme.helperTextFontWeight;
});

var LinearProgress = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  margin-bottom: ", ";\n  overflow: hidden;\n  position: relative;\n"])), function (props) {
  return props.theme.thickness;
}, function (props) {
  return props.theme.totalLineColor;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.helperText !== "" && "8px";
});

var LinearProgressBar = _styledComponents["default"].span(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  transform: ", ";\n  top: 0;\n  left: 0;\n  width: 100%;\n  bottom: 0;\n  position: absolute;\n  transition: ", ";\n  transform-origin: left;\n  ", ";\n  ", ";\n\n  @keyframes keyframes-indeterminate-first {\n    0% {\n      left: -35%;\n      right: 100%;\n    }\n    60% {\n      left: 100%;\n      right: -90%;\n    }\n    100% {\n      left: 100%;\n      right: -90%;\n    }\n  }\n\n  @keyframes keyframes-indeterminate-second {\n    0% {\n      left: -200%;\n      right: 100%;\n    }\n    60% {\n      left: 107%;\n      right: -8%;\n    }\n    100% {\n      left: 107%;\n      right: -8%;\n    }\n  }\n"])), function (props) {
  return props.backgroundType === "dark" ? props.theme.trackLineColorOnDark : props.theme.trackLineColor;
}, function (props) {
  return "translateX(-".concat(props.variant === "determinate" ? 100 - props.value : 0, "%)");
}, function (props) {
  return props.variant === "determinate" ? "transform .4s linear" : "transform 0.2s linear";
}, function (props) {
  return props.variant === "indeterminate" && "width: auto;";
}, function (props) {
  return props.variant === "indeterminate" ? props.container === "first" ? "animation: keyframes-indeterminate-first 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;" : "animation: keyframes-indeterminate-second 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;" : "";
});

var _default = DxcProgressBar;
exports["default"] = _default;